import { Form, Input, Typography } from "antd";
import React from "react";
import { t } from "i18next";
import { useContext } from "react";
import { StoreContext } from "../../../stores";
import { useState } from "react";
import { educationItems } from "../../../configs/const";

function Education(props) {
    const { form } = props;
    const { initialForm } = useContext(StoreContext);
    const [data, setData] = useState(
        initialForm?.education
            ? JSON.parse(initialForm?.education)
            : {
                  education_level: "",
                  education_branch: "",
                  education_school: "",
                  education_cert: "",
              }
    );


    return (
        <div className="child_groups">
            {educationItems.map((item) => (
                <div style={{ marginBottom: 12 }} key={item.key}>
                    <Typography.Text>{t(item.label)}</Typography.Text>
                    <Input
                        onChange={(e) => {
                            setData(Object.assign(data, { [item.key]: e.target.value }));
                            form.setFieldsValue({ education: JSON.stringify(data) });
                        }}
                        value={data[item.key]}
                        size="large"
                    />
                </div>
            ))}
        </div>
    );
}

export default Education;
